import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Text } from 'DVWebNodeUI'
import { tryCatch } from '../../utils/tryCatch'
import {
  isAmazonMaturityRatingBadge,
  isRegulatoryRatingBadge,
  isLocalRatingBadge,
} from '../../utils/ratingBadgeHelper'
import { MaturityRating } from 'DVWebNodeUI'

export interface IMaturityRatingBadgeProps {
  ratingBadge?: WpsRuntime.atv.wps.RatingBadgeProps
}

//TODO: AVWebDetailPage-2972
const ratingBadgeRender = (
  {
    displayText,
    description,
    localRatingLink
  }:
    | WpsRuntime.atv.wps.AmazonMaturityRatingBadgeProps
    | WpsRuntime.atv.wps.RegulatoryRatingBadgeProps,
) => {
  return(
    <MaturityRating rating={displayText.toUpperCase()} title={description} data-testid="rating-badge">
      {localRatingLink && (<Text string={localRatingLink} />)}
    </MaturityRating>
  )
}

const getLocalRatingBadge = (
  {
    countryCode,
    simplifiedId,
    description
  }: WpsRuntime.atv.wps.LocalRatingBadgeProps) => {
  const locale = countryCode.toLowerCase()

  return isValidLocale(locale) ? <MaturityRating rating={simplifiedId} locale={locale} title={description} data-testid="rating-badge" /> : null
}

const isValidLocale = (
  countryCode?: string
): countryCode is 'uk' | 'de' => {
  const acceptableLocales = ['uk', 'de']
  return Boolean(countryCode && acceptableLocales.includes(countryCode))
}

export const Rating = tryCatch(({ ratingBadge }: IMaturityRatingBadgeProps) => {
  if (!ratingBadge) {
    return null
  }

  if (isAmazonMaturityRatingBadge(ratingBadge)) {
    return ratingBadgeRender(ratingBadge)
  }

  if (isLocalRatingBadge(ratingBadge)) {
    return getLocalRatingBadge(ratingBadge)
  }

  if (isRegulatoryRatingBadge(ratingBadge)) {
    return ratingBadgeRender(ratingBadge)
  }

  return null
})
